const utility = require('./utility.service')
module.exports = utility
